import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './redux/rootReducer';
import { uMUsersApi } from './redux/apis/usersManagement/users/uMUsersApiSlice';
import { cMCampaignsApi } from './redux/apis/campaignsManagement/campaigns/cMCampaignsApiSlice';
import { cMTypesApi } from './redux/apis/campaignsManagement/types/cMTypesApiSlice';
import { cMCustomerCampaignApi } from './redux/apis/campaignsManagement/customerCampaign/cMCustomerCampaignApiSlice';
import { customerTicketsApi } from './redux/apis/customersManagement/tickets/customerTicketsApiSlice';
import { cMcustomerApi } from './redux/apis/customersManagement/customers/cMcustomerApiSlice';
import { utilsMCountriesApi } from './redux/apis/utilsManagement/countries/utilsMCountriesApiSlice';
import { cMChannelsApi } from './redux/apis/customersManagement/channels/cMChannelsApiSlice';
import { cMLoaApi } from './redux/apis/campaignsManagement/loa/cMLoaApiSlice';
import { cMcustomerServicesApi } from './redux/apis/customersManagement/services/cMcustomerServicesApiSlice';
import { sMServicesApi } from './redux/apis/servicesManagement/sMServicesApiSlice';
import { cMKeywordsApi } from './redux/apis/campaignsManagement/keywords/cMKeywordsApiSlice';
import { uMLanguagesApi } from './redux/apis/utilsManagement/languages/uMLanguagesApiSlice';
import { cMAdvancedKeywordsApi } from './redux/apis/campaignsManagement/advancedKeywords/cMAdvancedKeywordsApiSlice';
import { dMDomainsApi } from './redux/apis/domainsManagement/domains/dMDomainsApiSlice';
import { dMDomainsCategoryApi } from './redux/apis/domainsManagement/category/dMDomainsCategoryApiSlice';
import { dMDomainsIgnoreApi } from './redux/apis/domainsManagement/ignore/dMDomainsIgnoreApiSlice';
import { dMVrdMessagesApi } from './redux/apis/domainsManagement/vrdMessages/dMVrdMessagesApiSlice';
import { lMSearchEngineApi } from './redux/apis/linkManagement/searchEngine/lMSearchEngineApiSlice';
import { lMTubeApi } from './redux/apis/linkManagement/tube/lMTubeApiSlice';
import { lMTelegramApi } from './redux/apis/linkManagement/telegram/lMTelegramApiSlice';
import { lMChangeGetLinkApi } from './redux/apis/linkManagement/changeGetLink/lMChangeGetLinkApiSlice';
import { sMServicesCategoriesApi } from './redux/apis/servicesManagement/sMServicesCategoriesApiSlice';
import { dMIpAddressApi } from './redux/apis/domainsManagement/ipAddress/dMIpAddressApiSlice';
import { dMIspApi } from './redux/apis/domainsManagement/isp/dMIspApiSlice';
import { lmAppsStoresApi } from './redux/apis/linkManagement/app/stores/lmAppsStoresApiSlice';
import { lmAppsDataApi } from './redux/apis/linkManagement/app/data/lmAppsDataApiSlice';
import { lmAppsNameApi } from './redux/apis/linkManagement/apps/lmAppsApiSlice';
import { lmAppsStatusApi } from './redux/apis/linkManagement/app/status/lmAppsStatusApiSlice';
import { lmIptvApi } from './redux/apis/linkManagement/iptv/index/lmIptvApiSlice';
import { lmIptvStatusApi } from './redux/apis/linkManagement/iptv/status/lmIptvStatusApiSlice';
import { lmIptvServerApi } from './redux/apis/linkManagement/iptv/server/lmIptvServerApiSlice';
import { lmIptvTypeApi } from './redux/apis/linkManagement/iptv/type/lmIptvTypeApiSlice';
import { lmIptvReportsApi } from './redux/apis/linkManagement/iptv/reports/lmIptvReportsApiSlice';
import { lmM3uKeywordsApi } from './redux/apis/linkManagement/m3u/lmM3uKeywordsApiSlice';
import { lmM3uResponseMessagesApi } from './redux/apis/linkManagement/m3u/lmM3uResponseMessagesApiSlice';
import { dMDomainsXpathApi } from './redux/apis/domainsManagement/xpath/dMDomainsXpathApiSlice';
import { lMUgcSearchApi } from './redux/apis/linkManagement/ugc/lMUgcSearchApiSlice';
import { lMUgcSeasonApi } from './redux/apis/linkManagement/ugc/lMUgcSeasonApiSlice';
import { lMUgcEpisodeApi } from './redux/apis/linkManagement/ugc/lMUgcEpisodeApiSlice';
import { lMUgcSourceApi } from './redux/apis/linkManagement/ugc/lMUgcSourceApiSlice';
import { lmNewM3uApi } from './redux/apis/linkManagement/m3u/lmNewM3uApiSlice';
import { lMTubeChannelsApi } from './redux/apis/linkManagement/tube/lMTubeChannelsApiSlice';
import { dMDomainsTubeWhitelistApi } from './redux/apis/domainsManagement/domains/dMDomainsTubeWhitelistApiSlice';
import { reportsApiSlice } from './redux/apis/reports/reportsApiSlice';
import { bDDomainsApi } from './redux/apis/blockingDomainsManagement/bDDomainsApiSlice';
import { bDCategoriesApi } from './redux/apis/blockingDomainsManagement/bDCategoriesApiSlice';
import { bDActivitiesApi } from './redux/apis/blockingDomainsManagement/bDActivitiesApiSlice';
import { lmM3uFilesApi } from './redux/apis/linkManagement/m3u/lmM3uFilesApiSlice';
import { uMOpsApi } from './redux/apis/usersManagement/users/uMOpsApiSlice';
import { aMOpsApi } from './redux/apis/analyticsManagement/aMOpsApiSlice';
import { aMAnalyticsApi } from './redux/apis/analyticsManagement/aMAnalyticsApiSlice';
import { aMIptvAnalyticsApi } from './redux/apis/analyticsManagement/aMIptvAnalyticsApiSlice';
import { aMLiveStreamingStatsApi } from './redux/apis/analyticsManagement/aMLiveStreamingStatsApiSlice';
import { tMDistriputionApi } from './redux/apis/taskManagement/tMDistriputionApiSlice';
import { uMUserWeightsApi } from './redux/apis/usersManagement/users/uMUserWeightsApiSlice';
import { lmIptvFilesApi } from './redux/apis/linkManagement/iptv/media/lmIptvFilesApiSlice';
import { uMGuacamoleApi } from './redux/apis/utilsManagement/guacamole/uMGuacamoleApiSlice';
import { GuacamoleApi } from './redux/apis/GuacamoleManagment/GuacamoleApiSlice';
import { uMCollectorScheduleApi } from './redux/apis/utilsManagement/collectorSchedule/uMCollectorScheduleApiSlice';

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      uMUsersApi.middleware,
      utilsMCountriesApi.middleware,
      customerTicketsApi.middleware,
      cMCampaignsApi.middleware,
      cMTypesApi.middleware,
      cMCustomerCampaignApi.middleware,
      cMcustomerApi.middleware,
      cMChannelsApi.middleware,
      cMLoaApi.middleware,
      cMcustomerServicesApi.middleware,
      sMServicesApi.middleware,
      cMKeywordsApi.middleware,
      uMLanguagesApi.middleware,
      cMAdvancedKeywordsApi.middleware,
      dMDomainsApi.middleware,
      dMDomainsCategoryApi.middleware,
      dMDomainsIgnoreApi.middleware,
      dMVrdMessagesApi.middleware,
      lMSearchEngineApi.middleware,
      lMTubeApi.middleware,
      lMTelegramApi.middleware,
      lMChangeGetLinkApi.middleware,
      sMServicesCategoriesApi.middleware,
      dMIpAddressApi.middleware,
      dMIspApi.middleware,
      lmAppsStoresApi.middleware,
      lmAppsDataApi.middleware,
      lmAppsNameApi.middleware,
      lmAppsStatusApi.middleware,
      lmIptvApi.middleware,
      lmIptvStatusApi.middleware,
      lmIptvServerApi.middleware,
      lmIptvTypeApi.middleware,
      lmIptvReportsApi.middleware,
      lmM3uKeywordsApi.middleware,
      lmM3uResponseMessagesApi.middleware,
      dMDomainsXpathApi.middleware,
      lMUgcSearchApi.middleware,
      lMUgcSeasonApi.middleware,
      lMUgcEpisodeApi.middleware,
      lMUgcSourceApi.middleware,
      lmNewM3uApi.middleware,
      lMTubeChannelsApi.middleware,
      dMDomainsTubeWhitelistApi.middleware,
      reportsApiSlice.middleware,
      bDDomainsApi.middleware,
      bDCategoriesApi.middleware,
      bDActivitiesApi.middleware,
      lmM3uFilesApi.middleware,
      uMOpsApi.middleware,
      aMOpsApi.middleware,
      aMAnalyticsApi.middleware,
      aMIptvAnalyticsApi.middleware,
      aMLiveStreamingStatsApi.middleware,
      tMDistriputionApi.middleware,
      uMUserWeightsApi.middleware,
      lmIptvFilesApi.middleware,
      uMGuacamoleApi.middleware,
      GuacamoleApi.middleware,
      uMCollectorScheduleApi.middleware,
    ),

});

export default store;
